<template>
	<div>
		<div style="background-color: white;" v-if="OfflineTrainingsData.length==0">
			<a-result  title="暂无数据">
			   
			  </a-result>
		</div>
		<div v-for="(item,index) in OfflineTrainingsData" class="cardHover" style="width: 50.75rem;height: 260px;background: #FFFFFF;
		border-radius: 4px;position: relative;margin-bottom: 0.9375rem;">
				<div v-if="item.isRegular==1"
					style=" font-size: 2px;color: white; position: absolute; right: 1.5rem;top: 1.5rem; background-color: #FF8156;display: flex;justify-content: center;align-items: center;">
					<span style='transform: scale(0.92);'>定期</span>
					<div>
					</div>
				</div>
				<p class="title_t">
					{{item.title}}
				</p>
				<div class="title_b" style="display: flex;margin-left: 1.5625rem;">
					<p>平台：</p>
					<p>{{item.lab.labName}}</p>
				</div>
				<div class="title_b" style="display: flex;margin-left: 1.5625rem;">
					<p>培训时间：</p>
					<p>{{item.trainingDate}}</p>
				</div>
				<div class="title_b" style="display: flex;margin-left: 1.5625rem;" v-if="item.isRegular==1">
					<p>下期时间：</p>
					<p>{{item.nextPeriodTime}}</p>
				</div>
				<div class="title_b" style="display: flex;margin-left: 1.5625rem;">
					<p>培训地点：</p>
					<p>{{item.location}}</p>
				</div>
				<div class="title_b" style="display: flex;margin-left: 1.5625rem;">
					<p>报名上限：</p>
					<p>{{item.regCount==0?'不限制':item.regCount+'/个'}}</p>
				</div>
				<div style="display: flex;align-items: center;position: absolute;right: 1.25rem;bottom: 10px;">
					<a-button  @click="goToNoticeDetail(item)" style="width: 95px;height: 40px;margin-right: 24px;">详情</a-button>
					<div v-show="item.isRegular==2" >
						<a-popconfirm   placement="topLeft" title="请确认是否报名?" ok-text="是" cancel-text="否" @confirm="showCalendarModal(item)">
						
							<a-button v-if="item.statef=='1'" style="width: 95px;height: 40px;"   type="primary">
								报名
							</a-button>
							</a-popconfirm>
							<a-button v-if="item.statef=='2'" style="border-color: #F64C4C;width: 95px;height: 40px;opacity: 0.3;background: #F64C4C;"    type="primary">
								已过期
							</a-button>
							<a-button v-else-if="item.statef=='3'||item.statef=='5'||item.statef=='6'" style="border-color: #BAE7FF;width: 95px;height: 40px;opacity: 0.3;background: royalblue;"    type="primary">
								已报名
							</a-button>
							<a-button v-else-if="item.statef=='4'" style="width: 95px;height: 40px;background-color: gray;border-color: gray;"   type="primary">
								未开始
							</a-button>
							<!-- <a-button v-else style="width:6.625rem ;"   type="primary">
								报名
							</a-button> -->
					</div>
					
					
					<a-button v-show="item.isRegular==1" @click="showCalendarModal(item)" style="width: 95px;height: 40px;" type="primary">
						报名
					</a-button>
					<a-button v-show="item.isRegular==null" @click="showCalendarModal(item)" style="width: 95px;height: 40px;" type="primary">
						报名
					</a-button>
				</div>
				<a-modal :footer="null" class="signModal" title="详情" :visible="visible" @cancel="handleCancel">
					<div v-html="item.content" style="height: 26.1875rem;overflow-y: scroll;overflow-x: hidden;">
						
					</div>
		
				</a-modal>
				<a-modal  okText="报名" cancelText="取消"  width="824px" class="calendarModal" title="详情" :visible="calendarVisible"
					@cancel="calendarHandleCancel" @ok="showConfirm()" >
					<div style="height: 32rem;overflow-y: scroll;overflow-x: hidden;">
						<a-calendar  :value="date" @panelChange="onPanelChange"  @change="changeDateS"	@select="selectDates">
							<ul   slot="dateCellRender" slot-scope="value" class="events">
								<!-- style="position: absolute;top: 0.0625rem;left: 1px;right: 1px;bottom: 1px; background-color: blue;" -->
							      <div   style="display: flex;justify-content: center;align-items: center;" v-for="(item,index) in getListData(value)">
									  <div style="">
										  {{item.count}}
									  </div>
										<div style="color: orange;font-size: 13px;" v-if="item.isSignup==false">
											已报名
										</div>
										<div style="color:  #1890FF;font-size: 13px;" v-else-if="item.isSignup==true">
											可报名
										</div>
								  </div>
							    </ul>
							
						</a-calendar>
					</div>
		
				</a-modal>
				
				
			</div>
			<div style="position: absolute;bottom: 0;padding-bottom: 2rem;">
				<a-pagination :defaultPageSize="5" :pageSizeOptions="['5', '10', '20', '40']" v-model="queryPage.current"
					@showSizeChange="changeSize" @change="changeCurrent"
					style="display: block !important;margin-left: 15.625rem" size="small" :total="total" show-size-changer
					show-quick-jumper />
			</div>
	</div>
	
</template>

<script>
	import {RegOfflineTrainings,SelTrainingUser,OfflineTrainings} from '@/api/index.js'
	 import moment from 'moment'
	export default {
		props: ['data','ids'],
		data() {
			return {
				EducationLevel:'',
				total:0,
				OfflineTrainingsData:[],
				queryPage: {
					current: 1,
					pageSize: 5
				},
				datess:moment('2022-01-25'),
				date:'',
				visible: false,
				calendarVisible: false,
				trainDetails:[],
				offlineTrainingId:0,

			}
		},
		created(){
			
			this.getOfflineTrainings()
			
			var myDate = new Date();
		},
		methods: {
			getOfflineTrainings(){
				if(this.ids == '空白'){
					this.ids=undefined
				}
				let id = this.ids
				
				let data = {OfflineTrainingTypeId: id,page: this.queryPage.current,row: this.queryPage.pageSize ,name:window.localStorage.getItem('searchValues'),}
				OfflineTrainings(data).then((res)=>{
					this.OfflineTrainingsData = res.data.data
					console.log(res.data.data)
					this.total = res.data.totalCount
				})
			},
			goToNoticeDetail(data){
				
				this.$router.push({name:'noticeRichDetail',params:{data:data},query:{Ids:data.offlineTrainingId,state:2}})
				console.log(data)
			},
			showModal() {
				
					this.visible = true;
				
			},
			async goRegOfflineTrainings(data){
				 
			 	const res = await RegOfflineTrainings(data)
				console.log(res)
				if(res.data.state==true){
					this.calendarVisible = false
					this.$message.success('报名成功');
					this.getOfflineTrainings()
					
					
				}
				else{
					 this.$message.error(res.data.info);
				}
			},
			handleCancel(e) {
				console.log('Clicked cancel button');
				this.visible = false;
			},
			calendarHandleCancel(e) {
				this.calendarVisible = false;
			},
			async onPanelChange(value, mode) {
				console.log(value, mode);
				this.datess = value;
				console.log(moment(this.datess).format())
				const res = await SelTrainingUser({otid:this.offlineTrainingId,week:moment(this.datess).format()})
				this.trainDetails = res.data.data
			},
			async showCalendarModal(data) {
				let isLogin = window.localStorage.getItem('Authorization')
				var that = this
				if(!isLogin){
					let secondsToGo = 3;
					     const modal = this.$success({
					       title: '暂无权限操作，请前往登录再操作',
						    okText: '立即前往登录',
					       content: `${secondsToGo}秒后自动跳转前往登录`,
						   onOk() {
						   	that.$router.push({name:'login'})
						   },
					     });
					     const interval = setInterval(() => {
					       secondsToGo -= 1;
					       modal.update({
					         content: `${secondsToGo}秒后自动跳转前往登录`,
					       });
					     }, 1000);
					     setTimeout(() => {
					       clearInterval(interval);
						   that.$router.push({name:'login'})
					       modal.destroy();
					     }, secondsToGo * 1000);
						 return
				}
				let dateSearchs = this.date==''?new Date():this.date._d
				console.log(data.isRegular)
				
				if(data.isRegular==1){
				this.calendarVisible = true;
				this.offlineTrainingId = data.offlineTrainingId
				
				const res = await SelTrainingUser({otid:this.offlineTrainingId,week:dateSearchs})
				this.trainDetails = res.data.data
				console.log(this.trainDetails)
				}
				if(data.isRegular==2){
					console.log(data.offlineTrainingId)
					this.goRegOfflineTrainings({id:data.offlineTrainingId,Week:data.trainingDate})
				}
			},
			showConfirm() {
				var that = this
				console.log(that.date)
				
				let EducationLevel = this.EducationLevel
			     this.$confirm({
			             title: '确认是否报名',
			            content: <div style="display:flex"><span style="color:red;padding-right:5px">* </span><a-input  v-model={EducationLevel}  placeholder="请输入学历年级"></a-input></div>,
			             okText: '是',
			             cancelText: '否',
						  onOk() {
							  console.log(EducationLevel)
							 // if(EducationLevel==''){
								//  that.$message.error('请填写申请课题组名称')
								//  return
							 // }
						    console.log(that.date._d)
							that.goRegOfflineTrainings({EducationLevel:EducationLevel, id:that.offlineTrainingId,Week:that.date==''?new Date():that.date._d})
						         },
						         onCancel() {
						           console.log('Cancel');
						         },
			           });
			
			},
			changeDates(val){
				// console.log(val)
				      let week = moment(val).day()
				     
						  for(var i of this.data.sureCycle){
							  if(week==i){
								  return true
							  }
						  }
			},
			async changeDateS(val){
				this.date = val
				
			},
			selectDates(value){
				
				this.date = value
			},
			changeCurrent(val) {
				if(this.ids == '空白'){
					this.ids=undefined
				}
				this.queryPage.current = val
				this.$parent.getOfflineData({OfflineTrainingTypeId: this.ids,page: this.queryPage.current,row: this.queryPage.pageSize ,name:window.localStorage.getItem('searchValues'),})
			},
			changeSize(current, size) {
				if(this.ids == '空白'){
					this.ids=undefined
				}
				this.queryPage.pageSize = size
				this.queryPage.current = current
				this.$parent.getOfflineData({OfflineTrainingTypeId: this.ids,page: this.queryPage.current,row: this.queryPage.pageSize ,name:window.localStorage.getItem('searchValues'),})
			},
			 getListData(value) {
			      let date = moment(value).format().split('T')[0]
			   
				  for(var item of this.trainDetails){
					
						if(item.datetime.slice(0,10).replace('/','-').replace('/','-')==date){
							return [{
								count:item.count
							},
							{
								isSignup:item.isSignup
							}]
						}
				  }
				  }
			
		}
	}
</script>

<style scoped>
	.title_t {
		font-size: 1rem;
		color: rgba(0, 0, 0, 0.85);
		padding: 1.5625rem;
	}

	.title_b {
		font-size: 0.875rem;
		color: rgba(0, 0, 0, 0.65);
	}

	.a-button {
		width: 6.625rem !important;
		height: 2.5rem !important;
	}
</style>
<style lang="scss">
	
	.cardHover:hover{
		box-shadow: 0 0.125rem 0.5625rem 0.3125rem rgba(39, 143, 255,0.5);
		transform: scale(1.01);
	}
	.cardHover{
		transition-duration: 0.45s;
	}
	.events .ant-fullcalendar-date{
		background: red !important;
	}
	.calendarModal .ant-radio-group{
		display: none !important;
	}
	.signModal {
		.ant-modal-title {
			font-size: 1.125rem;
			color: rgba(0, 0, 0, 0.85);
			font-weight: 700;
		}
	}

	.calendarModal {
		.ant-modal-content {
			// width: 51.5rem!important;
			height: auto !important;
		}
		.ant-modal-mask{
			
		background-color: rgba(0, 0, 0, 0.1) !important;
		
		}
		.ant-modal-header{
			display: none;
		}
		.ant-modal-close{
			display: none;
		}
		.ant-btn{
			margin: 0 1.5625rem !important;
		}
	}

	
</style>
